export const PRICE_CONFIG_FIELDS = [
  {
    key: 'storeName',
    label: 'Kho',
    sortable: false,
    thStyle: { textAlign: 'left' }
  },
  {
    key: 'sellingPrice',
    label: 'Giá bán lẻ',
    sortable: false,
    thStyle: { textAlign: 'center' }
  },
  {
    key: 'wholesalePrice',
    label: 'Giá bán buôn',
    sortable: false,
    thStyle: { textAlign: 'center' }
  },
  {
    key: 'listedPrice',
    label: 'Giá niêm yết',
    sortable: false,
    thStyle: { textAlign: 'center' }
  },
  {
    key: 'updateChildProducts',
    label: 'Cập nhật sản phẩm con',
    sortable: false,
    thStyle: { textAlign: 'center', width: '15%' }
  },
  {
    key: 'actions',
    label: '',
    thStyle: { textAlign: 'center', width: '10%' }
  }
];

export const DEFAULT_PRICE_CONFIG = {
  storeId: null,
  storeName: '',
  companyId: null,
  companyName: '',
  sellingPrice: '',
  wholesalePrice: '',
  listedPrice: '',
  updateChildProducts: false
}; 